module.exports = __webpack_public_path__ + "img/island-tropical.73b32ff0.svg";